// extracted by mini-css-extract-plugin
export default {"ticker":"TickerBand_ticker__873rn","track":"TickerBand_track__maWfw","ticker-scroll":"TickerBand_ticker-scroll__lE1ec","copy":"TickerBand_copy__9z0ng"};